import React, { useState, useEffect, Fragment, useRef } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import moment from 'moment';
import {
  putAPI_Delete_QuestionSet,
  gAPI_Question_MessagesList,
  API_OpenAI_Assistant,
  postAPI_Create_QuestionSet,
} from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import short from 'short-uuid';
import ReactDragListView from 'react-drag-listview';
import { List, Typography } from 'antd';
import 'antd/dist/reset.css';
import Question from './Question';
import { Row, Collapse, Button, Card, CardBody } from 'reactstrap';
import { faEdit, faTrashAlt, faCopy, faClone } from '@fortawesome/free-solid-svg-icons';
import QuestionSetForm from './QuestionSetForm';
import CopyToClipboard from 'react-copy-to-clipboard';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
function QuestionSet({
  set,
  index,
  loadResponse,
  locale,
  quesionSetsList,
  roomTags,
  productList,
  propertyTags,
  productTags,
  formList,
  onDragEnd,
  activeIndex,
  setActiveIndex,
  propertyId,
  setResult,
  allSets,
}) {
  const [isAddQuestion, setIsAddQuestion] = useState(false);
  const [seriesName, setSeriesName] = useState(set.name);
  const [seriesDescription, setSeriesDescription] = useState(set.description);
  const [messagesList, setMessagesList] = useState([]);
  const [collapseQuestion, setCollapseQuestion] = useState(-1);

  useEffect(() => {
    if (set !== undefined) {
      AxiosAPI({
        methed: 'get',
        url: `${gAPI_Question_MessagesList}/?setId=${set.id}&lang=${locale === 'en' ? 'en-US' : locale
          }`,
      })
        .then((res) => {
          setMessagesList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [set]);

  const setCollaspQuestion = (e) => {
    if (collapseQuestion === e) {
      setCollapseQuestion(-1);
    } else {
      setCollapseQuestion(e);
    }
  };

  const updateSet = (updatedSet) => {
    setResult(prev =>
      prev.map(item =>
        item.id === updatedSet.id
          ? { ...item, ...updatedSet }
          : item
      )
    );

    setActiveIndex(-1);
  };
  const deleteSet = () => {
    let data = {
      Deleter: 'Dashboard',
    };
    try {
      if (
        set.openAiAssistantId !== undefined &&
        set.openAiAssistantId !== null &&
        set.openAiAssistantId !== ''
      ) {
        AxiosAPI({
          method: 'delete',
          url: `${API_OpenAI_Assistant}/delete/${set.openAiAssistantId}?id=${set.id}`,
        }).then((res) => { });
      }
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Delete_QuestionSet}/${set.id}`,
        data: data,
      }).then(() => {
        NotificationManager.success(
          'Conversation Flow deleted successfully',
          'Success',
          3000
        );
        loadResponse();
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleDuplicate = async () => {
    const baseName = set.name + ' Copy';
    const existingNames = (allSets || []).map(s => s.name);
    let newName = baseName;
    let counter = 1;

    while (existingNames.includes(newName)) {
      newName = `${baseName} (${counter})`;
      counter++;
    }

    const duplicateData = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      languageCode: locale,
      Name: newName,
      Type: set.type,
      Instructions: set.instructions,
      AssistantInstructions: set.assistantInstructions,
      Description: set.description,
      IsGroupVisible: set.isGroupVisible,
      flowTrainingData: set.flowTrainingData,
      flowInvokeApi: set.flowInvokeApi,
      Status: 'Active',
      Creator: 'Dashboard',
      publishConversationFlow: set.publishConversationFlow,
      OpenAiModel: set.openAiModel,
      OpenAiReasoningEfforts: 'minimal',
      OpenAiVerbosity: set.openAiVerbosity,
    };

    try {
      await AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_QuestionSet}`,
        data: duplicateData,
      });

      NotificationManager.success(
        'Conversation Flow duplicated successfully',
        'Success',
        3000
      );

      loadResponse();

    } catch (error) {
      NotificationManager.error(
        'Something went wrong while duplicating',
        'Error',
        3000
      );
    }
  };
  const formatDate = (date) => {
    if (!date) return '-';

    const parsed = moment(date, [
      'DD/MM/YYYY HH:mm:ss',
      'MM/DD/YYYY HH:mm:ss',
      'DD-MM-YYYY HH:mm:ss',
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD',
    ], true);

    return parsed.isValid()
      ? parsed.format('MMM DD, YYYY hh:mm a')
      : '-';
  };
  return (
    <Fragment>
      <Colxx
        xxs="12"
        xs="12"
        className="question-set-background mt-3"
        index={index}
      >
        <div>
          <div
            onClick={() => {
              setActiveIndex(prev => (prev === index ? -1 : index));
            }}
            style={{
              background: '#ffffff',
              padding: '2px 10px',
              borderRadius: '8px',
              marginBottom: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              minHeight: '38px',
              cursor: 'pointer',
              paddingTop: '8px',
            }}
          >

            {/* LEFT SECTION */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>

              {/* Title + Date */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                <span style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#111827',
                  lineHeight: 'normal',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  {seriesName}
                </span>

                <span style={{
                  fontSize: '12px',
                  color: '#6b7280',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  • Last updated: {formatDate(set.lastUpdated)}
                </span>
              </div>

            </div>

            {/* RIGHT SECTION */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px'
              }}
            >
              <span
                style={{
                  fontSize: '12.5px',
                  fontWeight: 500,
                  color: '#374151',
                  lineHeight: '1'
                }}
              >
                {set.type === 'DynamicConversationFlow'
                  ? 'Dynamic Conversation Flow'
                  : 'Static Conversation Flow'}
              </span>

              <FontAwesomeIcon
                icon={faEdit}
                style={{ cursor: 'pointer', color: '#3b82f6', fontSize: '13px', display: 'flex', alignItems: 'center' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveIndex(index);
                }}
              />

              <FontAwesomeIcon
                icon={faClone}
                style={{ cursor: 'pointer', color: '#6b7280', fontSize: '13px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDuplicate();
                }}
              />

              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ cursor: 'pointer', color: '#ef4444', fontSize: '13px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteSet();
                }}
              />
            </div>
          </div>

          {set.type !== 'DynamicConversationFlow' && (
            <Collapse isOpen={activeIndex === index}>
              {set.type === 'ConversationFlow' ||
                set.type === 'DynamicConversationFlow' ? (
                <Fragment>
                  <span className="collapse-span text-muted">
                    {seriesDescription}
                  </span>
                </Fragment>
              ) : (
                ''
              )}
              {activeIndex === index && (
                <Colxx
                  xxs="12"
                  className="mb-2 p-4"
                  style={{
                    border: '1px solid #e4e6ef',
                    borderRadius: '6px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                  }}
                >
                  <QuestionSetForm
                    dynmaicQuestionSet={set}
                    loadResponse={loadResponse}
                    actions={set.actions}
                    CancelQuestionSet={() => setActiveIndex(-1)}
                    setName={set.name}
                    seriesTrainingData={set.flowTrainingData}
                    seriesFlowInvokeApi={set.flowInvokeApi}
                    setInstructions={set.instructions}
                    setDescription={set.description}
                    seriesConversationFlow={set.publishConversationFlow}
                    aiModel={set.openAiModel}
                    aiAssistantId={set.openAiAssistantId}
                    updateSet={updateSet}
                    setId={set.id}
                    type={set.type}
                    setIsGroupVisible={set.isGroupVisible}
                    aiReasoningEfforts={set.openAiReasoningEfforts}
                    aiVerbosity={set.openAiVerbosity}
                  ></QuestionSetForm>
                </Colxx>

              )}
              {set.type !== 'DynamicConversationFlow' &&
                set.questions === null && (
                  <div className="mb-5 text-center question-set-border">
                    <Row>
                      <Colxx xxs="12" className="mb-4">
                        <div className="content text-center">
                          <img
                            src={
                              'https://bmbuiassetsprod.blob.core.windows.net/images/question.png'
                            }
                            alt="example"
                            width="auto"
                            className="img-thumbnail"
                          />
                        </div>
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="12" className="mb-4">
                        <h2>First Question you will ask to start filtering</h2>
                        <p>
                          First question you will ask to help people filter the
                          most relevant products & promotions for them
                        </p>
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="12" className="mb-4">
                        <Fragment>
                          <div
                            onClick={() => {
                              setIsAddQuestion(true);
                            }}
                            className="mb-3"
                          >
                            <Button
                              color="primary"
                              className="add-button"
                              size="xs"
                              style={{ width: '100%' }}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                              <span> </span>
                              Ask a Question
                            </Button>{' '}
                          </div>
                          {isAddQuestion && (
                            <Question
                              code={short.uuid()}
                              isDynamicFlow={
                                set.type === 'DynamicConversationFlow'
                                  ? true
                                  : false
                              }
                              index={index}
                              loadResponse={loadResponse}
                              setId={set.id}
                              setType={set.type}
                              setCollaspQuestion={setCollaspQuestion}
                              collapseQuestion={index}
                            />
                          )}{' '}
                        </Fragment>
                      </Colxx>
                    </Row>
                  </div>
                )}
              {set.questions !== null && (
                <ReactDragListView
                  nodeSelector=".ant-list-item.draggable-item"
                  lineClassName="dragLine"
                  onDragEnd={(fromIndex, toIndex) =>
                    onDragEnd(fromIndex, toIndex, 'QUESTION-LIST-ITEM', index)
                  }
                >
                  {set.questions.map((question, qindex) => {
                    return (
                      <List.Item key={qindex} className="draggable-item">
                        <div
                          className="d-flex flex-row"
                          style={{ width: '100%' }}
                        >
                          <span className="mr-1 draggable-item-span">
                            <a href="#">
                              <i className="simple-icon-menu svg-class"></i>
                            </a>
                          </span>
                          <Question
                            code={question.code}
                            index={qindex}
                            loadResponse={loadResponse}
                            QuestionId={question.id}
                            isDynamicFlow={
                              set.type === 'DynamicConversationFlow'
                                ? true
                                : false
                            }
                            Question={question}
                            setType={set.type}
                            messagesList={messagesList}
                            setCollaspQuestion={setCollaspQuestion}
                            collapseQuestion={collapseQuestion}
                            quesionSetsList={quesionSetsList}
                            roomTags={roomTags}
                            propertyTags={propertyTags}
                            productList={productList}
                            productTags={productTags}
                            formList={formList}
                          />
                        </div>
                      </List.Item>
                    );
                  })}
                </ReactDragListView>
              )}
              {set.type !== 'DynamicConversationFlow' &&
                set.questions !== null &&
                set.questions.length > 0 && (
                  <Fragment>
                    <div
                      onClick={() => {
                        setIsAddQuestion(true);
                      }}
                      className="mb-3 mt-2"
                    >
                      <Button
                        color="primary"
                        className="add-button"
                        size="xs"
                        style={{ width: '100%' }}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                        <span> </span>
                        Ask a Question
                      </Button>
                    </div>
                    {isAddQuestion && (
                      <Question
                        code={short.uuid()}
                        isDynamicFlow={
                          set.type === 'DynamicConversationFlow' ? true : false
                        }
                        index={index}
                        loadResponse={loadResponse}
                        setId={set.id}
                        setType={set.type}
                        setCollaspQuestion={setCollaspQuestion}
                        collapseQuestion={index}
                      />
                    )}
                  </Fragment>
                )}
            </Collapse>
          )}
          {set.type === 'DynamicConversationFlow' &&
            activeIndex === index && (
              <Colxx
                xxs="12"
                className="mb-2 p-4"
                style={{
                  border: '1px solid #e4e6ef',
                  borderRadius: '6px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}
              >
                <QuestionSetForm
                  dynmaicQuestionSet={set}
                  loadResponse={loadResponse}
                  actions={set.actions}
                  CancelQuestionSet={() => setActiveIndex(-1)}
                  setName={set.name}
                  seriesTrainingData={set.flowTrainingData}
                  seriesFlowInvokeApi={set.flowInvokeApi}
                  setInstructions={set.instructions}
                  setDescription={set.description}
                  seriesConversationFlow={set.publishConversationFlow}
                  aiModel={set.openAiModel}
                  aiAssistantId={set.openAiAssistantId}
                  updateSet={updateSet}
                  setId={set.id}
                  type={set.type}
                  setIsGroupVisible={set.isGroupVisible}
                  aiReasoningEfforts={set.openAiReasoningEfforts}
                  aiVerbosity={set.openAiVerbosity}
                />
              </Colxx>
            )}

        </div>
      </Colxx>
    </Fragment >
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(QuestionSet));
